import * as React from "react"
import PropTypes from "prop-types"
import Modal from "components/Modal/Modal"
import PDFTronViewer from "components/pdfs/PDFTronViewer/PDFTronViewer"
import "./PdfFullWindowModal.scss"

// api
import { useGetDocAnnotations } from "api/hooks/documents/useDocAnnotationsApi"

import usePdfAnnotations from "utilities/usePdfAnnotations"

const PdfFullWindowModal = ({ open, setOpen, file, setFile, getContainer }) => {
  const { isLoading: isAnnotLoading } = useGetDocAnnotations(file?.id)

  const {
    getServerUpdates,
    onAnnotationSelected,
    onAnnotationEvent,
    annotNotifHolder,
    AnnotModalError,
    setModalError,
  } = usePdfAnnotations(file?.id)

  if (!file || isAnnotLoading) return null

  return (
    <Modal
      open={open}
      onCancel={() => {
        setModalError(null)
        setOpen(false)
      }}
      footer={[]}
      hideImage={true}
      width="90vw"
      wrapClassName="pdf-full-win-modal"
      getContainer={getContainer}
    >
      <>
        {annotNotifHolder}
        <AnnotModalError />
        <PDFTronViewer
          metadata={file}
          file={file.document_file}
        />
      </>
    </Modal>
  )
}

PdfFullWindowModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  file: PropTypes.shape({
    id: PropTypes.number,
    file_id: PropTypes.string.isRequired,
  }),
  setFile: PropTypes.func,
}

export default PdfFullWindowModal
